import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspaceResourceFolders: {
        route: "/workspaces/:workspaceId/resource-folders",
        method: "GET"
    },
    updateWorkspaceResourceFolder: {
        route: "/workspaces/:workspaceId/resource-folders/:folderId",
        method: "PUT"
    },
    deleteWorkspaceResourceFolder: {
        route: "/workspaces/:workspaceId/resource-folders/:folderId",
        method: "DELETE"
    },
    createWorkspaceResourceFolder: {
        route: "/workspaces/:workspaceId/resource-folders",
        method: "POST"
    },
    updateWorkspaceResourceFolderResources: {
        route: "/workspaces/:workspaceId/resource-folders/:folderId/resources",
        method: "PUT"
    },
    updateWorkspaceResourceFolderUsers: {
        route: "/workspaces/:workspaceId/resource-folders/:folderId/users",
        method: "PUT"
    },
    getUserPermissionsToResourceFolder: {
        route: "/workspaces/:workspaceId/resource-folders/:folderId/user-permissions",
        method: "GET"
    }
};
